import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('audit-logs', function () {
    this.route('streaming', function () {
      this.route('configuration');
    });
  });
  this.route('platform-logs', function () {
    this.route('resource');
  });
});